import React from 'react';
import { Sparkle24Filled } from '@fluentui/react-icons';
import { ASK_AI_SUGGESTED_QUESTIONS } from '../../utils/askAiChatMeta';
import { isInsightsModuleAskOrigin } from '../../utils/intelligenceInsightsAskLensOrigin';
import AskAiComposer from './AskAiComposer';
import AskLensOriginIndicator from './AskLensOriginIndicator';
import styles from './askAi.module.css';

const AskAiEmptyState = ({
    question,
    onQuestionChange,
    contextMode,
    onContextModeChange,
    onCustomSelect,
    onOpenChangeContext,
    onOpenSavedPrompts,
    onSubmit,
    submitting,
    sourcesReady,
    sourcesProcessing,
    onSuggestedQuestion,
    insightsOrigin = null,
}) => {
    const moduleAsk = isInsightsModuleAskOrigin(insightsOrigin);
    const readyCount = sourcesReady != null ? Number(sourcesReady) : null;
    const processingCount =
        sourcesProcessing != null ? Number(sourcesProcessing) : null;
    const showSourcesBadge = readyCount != null || processingCount != null;

    return (
        <div className={styles.emptyState}>
            <div className={styles.emptyInner}>
                <div className={styles.emptyIconWrap}>
                    <Sparkle24Filled />
                </div>
                <h1 className={styles.emptyTitle}>What would you like to understand?</h1>
                <p className={styles.emptySubtitle}>
                    {moduleAsk
                        ? 'Ask a follow-up about this Intelligence Insights module. Answers use only that module’s stored analysis and evidence — not the wider project.'
                        : 'Ask a question grounded in your selected project evidence. Every answer is cited and traceable to source material.'}
                </p>
                {showSourcesBadge ? (
                    <div className={styles.emptySourcesBadge}>
                        <span className={styles.sourcesDot} aria-hidden />
                        {readyCount != null ? (
                            <span className={styles.sourcesReadyText}>
                                {readyCount} sources ready
                            </span>
                        ) : null}
                        {readyCount != null && processingCount != null && processingCount > 0 ? (
                            <span className={styles.sourcesSep}>·</span>
                        ) : null}
                        {processingCount != null && processingCount > 0 ? (
                            <span className={styles.sourcesProcessingText}>
                                {processingCount} processing
                            </span>
                        ) : null}
                    </div>
                ) : null}
                {moduleAsk ? (
                    <AskLensOriginIndicator origin={insightsOrigin} className={styles.originIndicatorEmpty} />
                ) : null}

                <AskAiComposer
                    question={question}
                    onQuestionChange={onQuestionChange}
                    contextMode={contextMode}
                    onContextModeChange={onContextModeChange}
                    onCustomSelect={onCustomSelect}
                    onOpenChangeContext={onOpenChangeContext}
                    onOpenSavedPrompts={onOpenSavedPrompts}
                    onSubmit={onSubmit}
                    submitting={submitting}
                    insightsOrigin={insightsOrigin}
                />

                <div className={styles.suggestedBlock}>
                    <div className={styles.suggestedHeader}>
                        <span>Suggested questions</span>
                        <span className={styles.verifiedHint}>
                            <span className={styles.verifiedDot} aria-hidden />
                            Evidence-verified answers only
                        </span>
                    </div>
                    <div className={styles.suggestedGrid}>
                        {ASK_AI_SUGGESTED_QUESTIONS.map(q => (
                            <button
                                key={q}
                                type="button"
                                className={styles.suggestedCard}
                                onClick={() => onSuggestedQuestion(q)}
                                disabled={submitting}>
                                {q}
                            </button>
                        ))}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default AskAiEmptyState;
